import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';

// Import configuration (sets up axios defaults)
import './config';

// Import components
import AuthCallback from './components/AuthCallback';
import LandingPage from './components/LandingPage';
import Dashboard from './components/Dashboard';
import LearnTab from './components/LearnTab';
import SettingsPage from './components/SettingsPage';
import ArchitectPage from './components/ArchitectPage';
import LegalPage from './components/LegalPage';
import Assessment from './components/Assessment';
import SmartAssessment from './components/SmartAssessment';
import GiftSuccessPage from './components/GiftSuccessPage';
import FitnessGoalSetup from './components/FitnessGoalSetup';
import JourneyDetail from './components/JourneyDetail';
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
import AdminBlog from './components/AdminBlog';

// =============================================================================
// APP ROUTER
// =============================================================================
function AppRouter() {
  const location = useLocation();
  
  // Check for auth callback (new token flow or legacy session_id)
  if (location.pathname === '/auth/callback' || location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/assessment" element={<SmartAssessment />} />
      <Route path="/assessment/basic" element={<Assessment />} />
      <Route path="/fitness/setup" element={<FitnessGoalSetup />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/journey/:id" element={<JourneyDetail />} />
      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/admin/blog" element={<AdminBlog />} />
      <Route path="/learn" element={<LearnTab />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/architect" element={<ArchitectPage />} />
      <Route path="/legal/:docType" element={<LegalPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/gift-success" element={<GiftSuccessPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

// =============================================================================
// MAIN APP
// =============================================================================
function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
